import { Navigate, Outlet } from 'react-router-dom';
import { useMe } from './useMe';

/* UI gate only — the API enforces admin access itself (adminOnly()). */
export function RequireAdmin() {
  const { me } = useMe();
  return me?.isAdmin ? <Outlet /> : <Navigate to="/" replace />;
}
